export enum LayoutContainerEnum {
  masterDetail = 'O',
}
